<div class="allocated-projects">
  <h1>Allocated projects</h1>
  <p class="subtitle">Projects awarded to your organization. Assign staff and machines, open GIS, upload work logs, and update allocated WBS.</p>

  <div *ngIf="loading" class="state">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="!loading && projects.length === 0" class="state empty">
    No projects have been allocated to you yet.
  </div>

  <div class="cards" *ngIf="!loading">
    <div class="card" *ngFor="let project of projects">
      <div class="card-top">
        <strong>{{ project.project_name }}</strong>
        <span>{{ project.boq_code }}</span>
      </div>
      <p *ngIf="project.parent_org_name">From {{ project.parent_org_name }}</p>
      <p class="muted">{{ project.boq_name }}</p>
      <p>{{ formatCurrency(project.bid_amount) }}</p>
      <p class="muted">Awarded: {{ formatDate(project.awarded_at) }}</p>
      <p class="wbs-count">
        {{ project.wbs_assigned_count || 0 }} WBS
        {{ (project.wbs_assigned_count || 0) === 1 ? 'activity' : 'activities' }} allocated
      </p>
      <div class="actions">
        <button type="button" (click)="viewProject(project)">View project</button>
        <button type="button" (click)="viewStaff(project)">Staff</button>
        <button type="button" (click)="viewMachines(project)">Machines</button>
        <button type="button" (click)="viewGis(project)">GIS</button>
        <button type="button" (click)="viewWorkLog(project)">Work log</button>
        <button type="button" (click)="viewDocuments(project)">Documents</button>
        <button type="button" (click)="viewDailyReports(project)">Daily reports</button>
        <button type="button" (click)="viewProgress(project)">Progress</button>
        <button type="button" class="primary" (click)="viewAllocatedWbs(project)">
          {{ (project.wbs_assigned_count || 0) > 0 ? 'Allocated WBS' : 'WBS not allocated yet' }}
        </button>
      </div>
    </div>
  </div>
</div>
